class Shiftlimitation{
    constructor(data){
        this.offset = data.offset;
        this.ignoreAOnPublicHoliday = parseInt(data.ignoreAOnPublicHoliday);
        this.timeIntervall = data.time / 60 * 4;
        this.name = data.name;
        this.numberOfShifts = parseInt(data.numberOfShifts);
        this.maximal = parseInt(data.maximal);
        this.after = parseInt(data.after);
        this.days = data.days;
        this.publicHolidayAsWorkingDay = parseInt(data.publicHolidayAsWorkingDay);
        this.isSumSingleDaysOverAllWeeks = parseInt(data.isSumSingleDaysOverAllWeeks);
        this.perCalenderWeek  = parseInt(data.perCalenderWeek);
        this.wishWindow = new Array(data.weeks);
        this.publicHolidays;
        this.timeUntil = data.timeUntil / 60 *4;
    }

    compareShiftlimitation(){
        for(let week = 1; week <= this.wishWindow.length; week++){
            this.wishWindow[week-1] = new WishWeekFromSixToTwelve(this.offset, week, this.ignoreAOnPublicHoliday);
            this.wishWindow[week-1].setDays();
        }
        this._setPublicHolidays();
        if(!this._compareShiftlimitationToWishwindow()){
            return "Die Schichtlimitierung " + this.name + " wird nicht beachtet. <br>";
        }else{
            return "";
        }
    }
    _compareShiftlimitationToWishwindow(){
        if(this.isSumSingleDaysOverAllWeeks == 0 && this.perCalenderWeek == 0){
            let sum = this._compareSumDaysOverOneWeekPerWishPlan();
            return this._isSumOfSumDaysAllowedOverOneWeekPerWishPlan(sum);
        }else if(this.isSumSingleDaysOverAllWeeks == 1 && this.perCalenderWeek == 0){
            let sum = this._compareSingleDaysOverAllWeeksPerWishPlan();
            return this._isSumOfSingleDaysAllowedOverAllWeeksPerWishPlan(sum);
        }else if(this.isSumSingleDaysOverAllWeeks == 0 && this.perCalenderWeek == 1){
            let sum = this._compareSumDaysOverOneWeekPerCalenderWeek();
            return this._isSumOfSumDaysAllowedOverOneWeekPerCalenderWeek(sum);
        }else if(this.isSumSingleDaysOverAllWeeks == 1 && this.perCalenderWeek == 1){
            let sum = this._compareSingleDaysOverAllWeeksPerCalenderWeek();
            return this._isSumOfSingleDaysAllowedOverAllWeeksPerCalenderWeek(sum);
        }
    }
    _isSumOfSingleDaysAllowedOverAllWeeksPerWishPlan(sum){
        for(let nrOfDay = 0; nrOfDay < sum.length ; nrOfDay++){
            if(this.days[nrOfDay]== "1") {
                if (this.maximal == 1 && sum[nrOfDay] > this._calcSumBetweenWorkingDaysAndHolidays(sum[nrOfDay], this.publicHolidays[nrOfDay])) {
                    return false;
                } else if (this.maximal == 0 && sum[nrOfDay] < this._calcSumBetweenWorkingDaysAndHolidays(sum[nrOfDay], this.publicHolidays[nrOfDay])) {
                    return false;
                }
            }
        }
        return true;
    }
    _isSumOfSumDaysAllowedOverOneWeekPerWishPlan(sum){
        if (this.maximal == 1 && sum > this._calcSumBetweenWorkingDaysAndHolidays(sum, this.publicHolidays)) {
            return false;
        } else if (this.maximal == 0 && sum < this._calcSumBetweenWorkingDaysAndHolidays(sum, this.publicHolidays)) {
            return false;
        }
        return true;
    }
    _isSumOfSumDaysAllowedOverOneWeekPerCalenderWeek(sum){
        for(let nrOfWeek = 0; nrOfWeek < sum.length ; nrOfWeek++) {
            if (this.maximal == 1 && sum[nrOfWeek] > this._calcSumBetweenWorkingDaysAndHolidays(sum[nrOfWeek], this.publicHolidays[nrOfWeek])) {
                return false;
            } else if (this.maximal == 0 && sum[nrOfWeek] < this._calcSumBetweenWorkingDaysAndHolidays(sum[nrOfWeek], this.publicHolidays[nrOfWeek])) {
                return false;
            }
        }
        return true;
    }
    _isSumOfSingleDaysAllowedOverAllWeeksPerCalenderWeek(sum){
        for(let nrOfWeek = 0; nrOfWeek < sum.length ; nrOfWeek++) {
            for(let day = 0; day < this.days.length; day++) {
                if (this.maximal == 1 && sum[nrOfWeek][day] > this._calcSumBetweenWorkingDaysAndHolidays(sum[nrOfWeek][day], this.wishWindow[nrOfWeek].isPublicHoliday(day)) && this.days[day] == "1") {
                    return false;
                } else if (this.maximal == 0 && sum[nrOfWeek][day] < this._calcSumBetweenWorkingDaysAndHolidays(sum[nrOfWeek][day], this.wishWindow[nrOfWeek].isPublicHoliday(day)) && this.days[day] == "1") {
                    return false;
                }
            }
        }
        return true;
    }
    _compareSumDaysOverOneWeekPerWishPlan(){
        let sum = 0;
        for(let day = 0; day < this.days.length; day++){
            if(this.days[day] == "1") {
                for (let week = 0; week < this.wishWindow.length; week++) {
                    sum += this._calcSum(day, week);
                }
            }
        }
        return sum;
    }
    _compareSingleDaysOverAllWeeksPerWishPlan(){
        let sum = new Array();
        for(let day = 0; day < this.days.length; day++){
            sum[day] = 0;
            if(this.days[day] == "1") {
                for (let week = 0; week < this.wishWindow.length; week++) {
                    sum[day] += this._calcSum(day, week);
                }
            }
        }
        return sum;
    }
    _compareSingleDaysOverAllWeeksPerCalenderWeek(){
        let sum = new Array();
        for (let week = 0; week < this.wishWindow.length; week++) {
            sum[week] = new Array();
            for(let day = 0; day < this.days.length; day++){
                sum[week][day] = 0;
            }
        }
        for (let week = 0; week < this.wishWindow.length; week++) {
            for(let day = 0; day < this.days.length; day++){
                if(this.days[day] == "1") {
                    sum[week][day] += this._calcSum(day, week);
                }
            }
        }
        return sum;
    }
    _compareSumDaysOverOneWeekPerCalenderWeek(){
        let sum = new Array();
        for (let week = 0; week < this.wishWindow.length; week++) {
            sum[week] = 0;
            for (let day = 0; day < this.days.length; day++) {
                if (this.days[day] == "1") {
                    sum[week] += this._calcSum(day, week);
                }
            }
        }
        return sum;
    }
    _calcSum(day, week){
        if (this.after == 1) {
            return this._isAOnWishWindowDaysAfterTime(day, week);
        }
        else if(this.after == 2){
            return this._isABetweenBeforeAndAfter(day, week);

        } else {
            return this._isAOnWishWindowDaysBeforeTime(day, week);
        }

    }
    _isAOnWishWindowDaysAfterTime(day, week){
        if (this.wishWindow[week].isAOnDaysAfterTime(day, this.timeIntervall)){
            return 1;
        }else{
            return 0;
        }
    }
    _isAOnWishWindowDaysBeforeTime(day, week){
        if (this.wishWindow[week].isAOnDaysBeforeTime(day, this.timeIntervall-1)) {
            return 1;
        }else{
            return 0;
        }
    }
    _isABetweenBeforeAndAfter(day, week){
        // if((this.wishWindow[week].isAOnDaysBeforeTime(day, this.timeUntil) == true) && (this.wishWindow[week].isAOnDaysAfterTime(day, this.timeIntervall) == true)){
        //     return 1;
        // }
        if(this.wishWindow[week].isAOnDaysBetweenTimeIntervals(day, this.timeIntervall, this.timeUntil)){
            return 1;
        }
        else{
            return 0;
        }
    }
    _setPublicHolidays(){
        if(this.isSumSingleDaysOverAllWeeks == 1){
            this._setPublicHolidaysForSingleWeekdaysOverAllWeeks();
        }else if(this.isSumSingleDaysOverAllWeeks == 0 && this.perCalenderWeek == 0){
            this._setPublicHolidaysForSingleWeekdaysOverAllWeeksPerWishPlan();
        }else{
            this._setPublicHolidaysForWeekdaysOverOneWeeks();
        }
    }
    _setPublicHolidaysForSingleWeekdaysOverAllWeeks(){
        this.publicHolidays = new Array();
        for (let day = 0; day < this.days.length; day++) {
            this.publicHolidays[day] = 0;
        }
        for(let week = 0; week < this.wishWindow.length; week++) {
            for (let day = 0; day < this.days.length; day++) {
                this.publicHolidays[day] += this._sumUpPublicHolidays(week, day);
            }
        }
    }
    _setPublicHolidaysForWeekdaysOverOneWeeks() {
        this.publicHolidays = new Array();
        for(let week = 0; week < this.wishWindow.length; week++) {
            this.publicHolidays[week] = 0;
            for (let day = 0; day < this.days.length; day++) {
                this.publicHolidays[week] += this._sumUpPublicHolidays(week, day);
            }
        }
    }
    _setPublicHolidaysForSingleWeekdaysOverAllWeeksPerWishPlan(){
        this.publicHolidays = 0;
        for(let week = 0; week < this.wishWindow.length; week++) {
            for (let day = 0; day < this.days.length; day++) {
                this.publicHolidays += this._sumUpPublicHolidays(week, day);
            }
        }
    }
    _sumUpPublicHolidays(week, day){
        if (this.days[day] == true) {
            if (this.publicHolidayAsWorkingDay == 0) {
                let test = this.wishWindow[week].isPublicHoliday(day);
                return this.wishWindow[week].isPublicHoliday(day);
            }
        }
        return 0;
    }
    _calcSumBetweenWorkingDaysAndHolidays(sum, numberOfPublicHolidays){
        if(this.maximal == 1){
            if(sum < numberOfPublicHolidays){
                return this.numberOfShifts;
            }
            return this.numberOfShifts + numberOfPublicHolidays;
        }else{
            return this.numberOfShifts - numberOfPublicHolidays;
        }
    }
}